var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95 10H25C21.0254 10.0119 17.217 11.596 14.4065 14.4065C11.596 17.217 10.0119 21.0254 10 25V69.3L29.4 49.9C32.2585 47.1793 36.0537 45.6619 40 45.6619C43.9463 45.6619 47.7415 47.1793 50.6 49.9L64.955 64.335L69.395 59.895C72.2131 57.0927 76.0258 55.5197 80 55.5197C83.9742 55.5197 87.7869 57.0927 90.605 59.895L110 79.3V25C109.988 21.0254 108.404 17.217 105.593 14.4065C102.783 11.596 98.9746 10.0119 95 10Z",
    fill: "#FFBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 49.8983C47.7415 47.1776 43.9463 45.6602 40 45.6602C36.0537 45.6602 32.2585 47.1776 29.4 49.8983L10 69.2983V94.9983C10.0119 98.9729 11.596 102.781 14.4065 105.592C17.217 108.402 21.0254 109.986 25 109.998H95C97.017 109.997 99.013 109.589 100.869 108.799C102.724 108.008 104.402 106.852 105.8 105.398L50.6 49.8983Z",
    fill: "#FFBD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M109.998 79.2898L90.6031 59.8948C87.785 57.0925 83.9724 55.5195 79.9981 55.5195C76.0239 55.5195 72.2112 57.0925 69.3931 59.8948L64.9531 64.3348L105.778 105.38C108.488 102.605 110.003 98.8798 109.998 94.9998V79.2898Z",
    fill: "#FFBD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.19f577b21785224459085c932aabab01.svg";
export { ForwardRef as ReactComponent };